<template>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row" v-if="userData.permissions['view_pm']==1">  
      <div class="row">
        <div class="col-12">
          <div class="card shadow-lg">
            <div class="card-body">
              <div class="mb-2 float-end">
                 <b-button v-b-modal.new-products size="sm" variant="primary"><i class="mdi mdi-plus"></i> Add Pocket Money</b-button>
              </div>
              <div class="my-2">
                <div class="row">
                  <b-form-group class="col-md-3" label="Term">
                    <v-select :options="schoolterms" placeholder="Select Term" v-model="schoolterm" label="name"></v-select>
                  </b-form-group>
                  <b-form-group class="col-md-3" label="Year">
                    <v-select :options="years" placeholder="Select Year" v-model="year"></v-select>
                  </b-form-group>
                  <div class="col-md-4 mt-md-4 mt-2 p-lg-0">
                  <b-button variant="primary" @click="FilterData()"><i class="mdi mdi-account-search"></i> Filter</b-button>
                </div>
              </div>
              </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                    <label class="d-inline-flex align-items-center">
                      Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                 </template>
                 <template #cell(student_id)="data">
                   {{ data.item.student.student_id }} 
                 </template>
                <template #cell(student)="data">
                  {{ data.item.student.first_name }} {{ data.item.student.last_name }}
                </template>
                <template #cell(schoolterm)="data">
                  {{ data.item.schoolterm.name }} 
                </template>
                <template #cell(payoption)="data">
                  {{ data.item.payoption.name }} 
                </template>
                <template #cell(amount)="data">
                  {{ commas(data.item.amount) }} 
                </template>
                <template #cell(addedby)="data">
                  {{ data.item.addedby }}
                </template>
                <template #cell(actions)="data">
                  <div class="btn-group">
                  <b-button @click="remove(data.item.id)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                  </div>
                </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <b-modal id="new-products" centered title="New  Record" title-class="font-18" hide-footer>
          <form @submit.prevent="addproducts">
              <div class="form-group mb-2">
                <input v-model="id" type="hidden">
                <label>Student : <small class="text-primary"></small></label>
                <multiselect v-model="student" :options="students" placeholder="Select Student" :custom-label="customLabel" ></multiselect>
                <label>Term</label>
                <multiselect v-model="schoolterm" label="name" :options="schoolterms" ></multiselect>
                <label>Year</label>
                <multiselect v-model="year"  :options="years"></multiselect>
              <label>Payment Method</label>
              <multiselect v-model="payoption" label="name" :options="paymentoptions" ></multiselect>
              <label>Amount</label>
              <input v-model="amount" type="number" :min="0" class="form-control" />
              </div>
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-products')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="success"  ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
          </form>
      </b-modal>
  
      <b-modal id="delete-products" centered title="Delete Record" title-class="font-18" hide-footer>
          <form @submit.prevent="removeproducts">
              <input v-model="id" type="hidden">
              Are you sure you want to delete the  pocket money record ?
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-products')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="success" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
          </form>
      </b-modal>
    </div>  
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center><span class="text-primary h4">You have no permission to view the Dashboard.</span></center>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
          </div>
        </div>
      </div>
    </div>
  
    </Layout>
  </template>
  
  <script>
  import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { paymentoptionComputed, paymentoptionMethods, pocketmoneyComputed, pocketmoneyMethods, schooltermComputed, schooltermMethods, studentComputed, studentMethods } from "@/state/helpers";
import axios from "axios";
import Multiselect from "vue-multiselect";
import Layout from "../../layouts/main";
  
  export default {
    page: {
      title: " Pocket Money",
      meta: [{ name: "description", content: appConfig.description,},],
    },
    components: {
      Layout,PageHeader, Multiselect,
    },
    data() {
      return {
        userData: JSON.parse(localStorage.getItem("user")),
        title: "Pocket Money",
        items: [ {text: "Dashboard",to: "/",}, {text: "Pocket Money",active: true, }, ],
        TotalRows: 1,
        currentPage: 1,
        perPage: 10,
        Options: [10, 50, 100, 150, 200],
        filter: null,
        todoFilter: null,
        filterOn: [],
        sortDesc: true,
        isBusy: true,
        fields: [
            { key: 'index', label: '#', visible: true },
            { key: 'id', label: 'ID', visible: false },          
            { key: 'student', label: 'Name', visible: true },
            { key: 'schoolterm', label: 'Term', visible: true },
            { key: 'year', label: 'Year', visible: true },
            { key: 'amount', label: 'Amount', visible: true },
            { key: 'payoption', label: 'Payment method', visible: true },
            { key: 'addedon', label: 'Date added', visible: true },
            { key: 'addedby', label: 'Added By', visible: true },
            { key: 'actions', label: 'Actions', visible: true },
          ],
        id:'',student_id:'',student:"",schoolterm:'',
        year:new Date().getFullYear(),amount:'',payoption:'',name:'',first_name:'',last_name:'',
      }
    },
    computed: {
      ...pocketmoneyComputed,
      ...studentComputed,
      ...schooltermComputed,
      ...paymentoptionComputed,
      List() { return this.pocketmoney.length; },
      Fields() { return this.fields.filter(field => field.visible) },
      Items() { return this.pocketmoney.map((d) => ({...d }))},
      IsBusy() { let a=false; if (this.pocketmoney.length>0) { a=false;} else { a=true;} return a },
      years() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 10;
      const endYear = currentYear;
      const yearArray = [];
      for (let year = startYear; year <= endYear; year++) {  yearArray.push(year);  }
      return yearArray;
    },
    },
    mounted() {
      this.fetchMoney();
      this.fetchSchoolTerms();
      this.fetchStudents();
      this.fetchPaymentoptions();
      this.TotalRows = this.pocketmoney.length;
      this.isBusy=false;
    },
    methods: {
      ...pocketmoneyMethods,
      ...studentMethods,
      ...schooltermMethods,
      ...paymentoptionMethods,
    commas(x) { 
  if (x == null || x == undefined) return '0'; 
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); 
},
    customLabel(student) {
   return `${student.student.first_name} ${student.student.last_name} ${student.class.name } ${student.stream.name }`;
},
      Filtered(filteredItems) {
        this.TotalRows = filteredItems.length;
        this.currentPage = 1;
      },
      remove(id){
        this.id=id;
        this.$bvModal.show('delete-products')
      },
      async addproducts() { 
        let formData = new FormData();
        formData.append("student", this.student.student.student_id);
        formData.append("schoolterm", this.schoolterm.id);
        formData.append("year", this.year);
        formData.append("payoption", this.payoption.id);
        formData.append("amount", this.amount);
        let url = "/addpocketmoney";
        await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
            this.fetchMoney();
            this.$bvModal.hide('new-products');
            this.$swal({ title:'Success', text:response.data.message, icon:'success'});
        }
        });
      },
      async removeproducts() { 
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removepocketmoney";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchMoney();
          this.$bvModal.hide('delete-position');
          this.$swal({ title:'Success', text:response.data.message, icon:'success'});
        }
      });
      },
    FilterData() {
      this.filterPM({schoolterm:this.schoolterm.id,year:this.year,});
    },
    },
  };
  </script>